import { fetchWithFallback } from "../OrgUsageAnalytics/api";

// Mounted at /admin/demo-invites on the backend. The backend verifies the
// Firebase ID token that fetchWithFallback sends, not just the userId.
const BASE = "/demo-invites";

export async function listDemoInvites(env) {
  return fetchWithFallback(BASE, {}, { env });
}

// The response carries the invite link once; the backend keeps only its hash.
export async function createDemoInvite(env, invite) {
  return fetchWithFallback(BASE, {}, { env, method: "POST", body: invite });
}

export async function revokeDemoInvite(env, inviteId) {
  return fetchWithFallback(
    `${BASE}/${encodeURIComponent(inviteId)}/revoke`,
    {},
    { env, method: "POST", body: {} },
  );
}

export async function resetDemoInviteDevices(env, inviteId) {
  return fetchWithFallback(
    `${BASE}/${encodeURIComponent(inviteId)}/reset-devices`,
    {},
    { env, method: "POST", body: {} },
  );
}

export async function extendDemoInvite(env, inviteId, expiresInDays) {
  return fetchWithFallback(
    `${BASE}/${encodeURIComponent(inviteId)}/extend`,
    {},
    { env, method: "POST", body: { expiresInDays } },
  );
}

// Issues a new link; the old one stops working and bound devices are released.
export async function regenerateDemoInviteLink(env, inviteId, { sendEmail = false } = {}) {
  return fetchWithFallback(
    `${BASE}/${encodeURIComponent(inviteId)}/regenerate-link`,
    {},
    { env, method: "POST", body: { sendEmail } },
  );
}
